import request from '@/utils/request'

let NoticeApi = {
  /*列表*/
  noticeList(data, errorback) {
    return request._post('/shop/notice.Notice/index', data, errorback);
  },
  /*列表详情*/
  noticeDetail(data, errorback) {
    return request._get('/shop/notice.Notice/detail', data, errorback);
  },
  /*添加*/
  noticeAdd(data, errorback) {
    return request._post('/shop/notice.Notice/add', data, errorback);
  },
  /*修改*/
  updatenotice(data, errorback) {
    return request._post('/shop/notice.Notice/edit', data, errorback);
  },
  /*删除*/
  noticedelete(data, errorback) {
    return request._post('/shop/notice.Notice/delete', data, errorback);
  },
  /*是否显示*/
  noticeshow(data, errorback) {
    return request._post('/shop/notice.Notice/isShow', data, errorback);
  },
  // 技师报备
  /*列表*/
  getReportList(data, errorback) {
    return request._post('/shop/order.order/getReportList', data, errorback);
  },
  // /*列表详情*/
  // noticeDetail(data, errorback) {
  //   return request._get('/shop/notice.Notice/detail', data, errorback);
  // },
}

export default NoticeApi;



// WEBPACK FOOTER //
// ./src/api/notice.js